import React                            from 'react';
import {render} from 'react-dom';
import FloatingNotifications            from '../components/Notifications/FloatingNotifications';

/**
 * @param {string} containerId
 */
function run(containerId) {
	const container = document.getElementById(containerId);
	if (container) {
		render(<FloatingNotifications />, container);
	}
}

export {run};
